import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
export const ATTENDEESMESSAGING_TOTAL_COMMUNICATION =
  "ATTENDEESMESSAGING_TOTAL_COMMUNICATION";
export const ATTENDEESMESSAGING_TOTAL_MSGENGMNTBARCHART =
  "ATTENDEESMESSAGING_TOTAL_MSGENGMNTBARCHART";

// [Attendee Communication] Attendees who sent and received at least one message
const attendeesmessagingcommunicationcount = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=atndscommcnt&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        dispatch({
          type: ATTENDEESMESSAGING_TOTAL_COMMUNICATION,
          payload: { response: data, count: data.resource.length },
        });
        callback({
          error: 0,
          data: "Analytics Attendees Total Attendee Communication Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Messaging Engagement (Chart view of how attendees communicated over the selected date range)
const attendeesmessagingMsgengmntbarchart = (session, daterange, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=attndsMsgEngmntData`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "attndsMsgEngmntData",
        eventid: session.eventid,
        fromDate: daterange.from,
        toDate: daterange.to,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        dispatch({
          type: ATTENDEESMESSAGING_TOTAL_MSGENGMNTBARCHART,
          payload: { response: data.resource },
        });
        callback({
          error: 0,
          data: "Analytics Attendees Messaging Engagement Communication Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export {
  attendeesmessagingcommunicationcount,
  attendeesmessagingMsgengmntbarchart,
};
